import { MenuActionIds } from '../../../../base';

export const useTableCallbacks = () => {
    const onMenuItemClick = (
        cellId: number,
        _row: Record<string, string> | undefined,
        actionId: string | undefined
    ) => {
        switch (actionId) {
            case MenuActionIds.Edit:
                console.log('Edit User clicked:', cellId);
                break;
            case MenuActionIds.Delete:
                console.log('Remove User clicked:', cellId);
                break;
            case MenuActionIds.ResendInvite:
                console.log('Resend Invite clicked:', cellId);
                break;
            default:
                break;
        }
    };

    return { onMenuItemClick };
};
